import { Resources } from 'constants/resources';

import ListAltIcon from '@mui/icons-material/ListAlt';
import { useRecordContext } from 'react-admin';
import { Box } from 'shared/mui/Box/Box';
import { LinkButton } from 'shared/mui/Buttons';
import { Tooltip } from 'shared/mui/Tooltip';
import { Typography } from 'shared/mui/Typography';
import { Provider } from 'types/embedded/provider';

export const ProvidersListDatagridWhiteIpsField: React.FC = () => {
  const record = useRecordContext<Provider>();

  if (!record) {
    return <></>;
  }

  return record.whiteIpAddressesCount ? (
    <LinkButton
      label="Перейти"
      pathParams={{
        resource: Resources.Providers,
        id: record.id,
        type: 'show',
        pathSuffix: '/1',
      }}
      startIcon={<ListAltIcon sx={{ fontSize: '18px' }} />}
    />
  ) : (
    <Tooltip
      arrow
      title={
        <Typography fontSize={12} maxWidth="250px">
          Здесь пока нет белых IP адресов.Чтобы добавить белый IP адрес, нажмите кнопку
          &#34;Добавить&#34;.
        </Typography>
      }
    >
      <Box>
        <LinkButton
          label="Добавить"
          pathParams={{
            resource: Resources.Providers,
            id: record.id,
            type: 'show',
            pathSuffix: '/1',
          }}
          queryParams={{
            filter: {
              create: true,
            },
          }}
          startIcon={<ListAltIcon sx={{ fontSize: '18px' }} />}
        />
      </Box>
    </Tooltip>
  );
};
